module.exports = __webpack_public_path__ + "js/0.d73c3a71.worker.js"